import Vue from 'vue'
import App from './App.vue'

import '@/setup/simpli'
import '@/setup/settings'
import '@/setup/vendor'

import {$} from 'simpli-web-sdk'
import {store} from '@/store'
import {Validator} from 'vee-validate'

Validator.extend('email_domains', {
  validate: (value: string) => {
    if (!value) return true
    const domains = value.split(',').map(d => d.trim())
    return domains.every(
      domain => domain.startsWith('@') && domain.includes('.')
    )
  },
})

new Vue({
  router: $.router,
  i18n: $.i18n,
  store,
  render: h => h(App),
}).$mount('#app')

// @ts-ignore
window.appLoader.finish()
